import { State } from "../Model/State";
export class MeService {
    constructor(authorizationService, usersService) {
        this.authorizationService = authorizationService;
        this.usersService = usersService;
        this.me = new State(null);
        authorizationService.hasToken.subscribe(hasToken => {
            if (hasToken) {
                this.refreshMe();
            }
            else {
                this.clearMe();
            }
        });
    }
    getMePromise() {
        return new Promise(resolve => {
            let resolved = false;
            const unsub = this.me.subscribe(me => {
                if (!me || resolved) {
                    return;
                }
                resolved = true;
                window.setTimeout(() => unsub(), 0);
                resolve(me);
            });
        });
    }
    async refreshMe() {
        if (!this.authorizationService.hasToken.value) {
            this.clearMe();
            return;
        }
        try {
            this.me.set(await this.usersService.getMe());
        }
        catch (_a) {
            this.authorizationService.clearToken();
        }
    }
    clearMe() {
        this.me.set(null);
    }
}
